"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheConsultant() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4473" id="the-consultant" ref={sectionRef} className="relative min-h-screen w-full overflow-hidden bg-background">
      <div className="flex flex-col lg:flex-row min-h-screen w-full">
        {}
        <div className="relative w-full lg:w-[58%] min-h-[60vh] lg:min-h-screen overflow-hidden">
          <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/myles_dacres_surrealist_editorial.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/myles_dacres_surrealist_editorial.png-wvc-sizes" alt="Surrealist editorial portrait of Myles Dacres in a sculptural natural environment" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[2000ms] ease-out will-change-transform" style={{
          transform: isVisible ? "scale(1)" : "scale(1.1)"
        }} src="https://mylesdacres.com/wp-content/uploads/2026/07/ChatGPT-Image-Jul-14-2026-08_54_53-PM-1.png" />
          {}
          <div className="absolute inset-0 bg-black/5 pointer-events-none" />
        </div>

        {}
        <div className="relative w-full lg:w-[42%] flex items-center justify-center px-8 py-24 sm:px-16 lg:px-24 bg-background">
          <div className="max-w-[420px] w-full transition-all duration-[1200ms] ease-out" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(30px)"
        }}>
            {}
            <div className="mb-12">
              <span className="text-[10px] font-default tracking-[0.4em] uppercase text-accent">
                MD-01 / The Approach
              </span>
            </div>

            {}
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-default font-normal leading-[1.1] tracking-tighter text-foreground mb-12">
              You built <br />
              something real.
            </h2>

            {}
            <div className="space-y-8 mb-16">
              <p className="text-lg font-default leading-relaxed text-foreground/80">
                Does the internet know it exists? In a crowded digital landscape, 
                clarity is your greatest competitive advantage.
              </p>
              <p className="text-lg font-default leading-relaxed text-foreground/80">
                I help creative brands cut through the noise. We don't chase 
                trends; we build authority through disciplined, intentional 
                marketing that resonates.
              </p>
            </div>

            {}
            <div className="mb-16">
              <p className="text-[11px] font-default tracking-[0.2em] uppercase text-foreground/60">
                Myles Dacres — Creative Consultant
              </p>
            </div>

            {}
            <Button asChild variant="link" className="group p-0 h-auto text-[11px] font-default tracking-[0.3em] uppercase no-underline hover:no-underline text-foreground">
              <Link to="/AboutPage" className="inline-flex items-center gap-4">
                <span className="relative py-1">
                  Learn my approach
                  <span className="absolute left-0 bottom-0 h-px w-full bg-foreground origin-left scale-x-100 transition-transform duration-700 ease-in-out group-hover:scale-x-0" aria-hidden="true" />
                  <span className="absolute left-0 bottom-0 h-px w-full bg-primary origin-right scale-x-0 transition-transform duration-700 ease-in-out group-hover:scale-x-100" aria-hidden="true" />
                </span>
                <ArrowRight className="size-4 transition-transform duration-500 ease-out group-hover:translate-x-2" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}